var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "announcement section" },
      [
        _c("p", [_vm._v(_vm._s(_vm.$t("confirmInAppPurchase.title")))]),
        _c("div", { staticClass: "description" }, [
          _c("div", { staticClass: "margin-bottom" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("confirmInAppPurchase.description")) + " "
            ),
          ]),
        ]),
        _c(
          "router-link",
          {
            staticClass: "button-design back",
            attrs: { to: { name: "paymentManagement" } },
          },
          [_vm._v(_vm._s(_vm.$t("confirmInAppPurchase.backButton")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }